module.exports = __webpack_public_path__ + "static/media/manufacturing.c74e09be.mp4";